import { AxiosResponse } from 'axios'

import { FetchResponse } from '../fetch'

import { getLocationHeader } from './get-location-header'
import { parseLastPathVariable } from './url'

export const getCreatedEntityGuidFrom201Response = (response: AxiosResponse | FetchResponse): string | undefined => {
  if (response.status !== 201) {
    throw new Error('Can\'t parse location from non 201 status response')
  }
  const location = getLocationHeader(response.headers)
  const guid = parseLastPathVariable(location)

  return guid
}
